import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const violationDetailTaskCheckConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default violationDetailTaskCheckConfig;
